var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tc-popup",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.close($event)
        }
      }
    },
    [
      _c("div", { staticClass: "pop-content" }, [
        _c(
          "div",
          {
            staticClass: "pop-box",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c(
              "a",
              {
                staticClass: "close",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close($event)
                  }
                }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("h2", [_vm._v("Waiver")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Please consult a medical professional before beginning this or any other workout program. These are ACTIVE workshops- be prepared to move if participating. Kathryn Ross-Nash New York Pilates, LLC or Kathryn Ross -Nash are not responsible for any injury or issue incurred while executing a workout/ workshop. Please consult your Medical Professional before beginning this or another work program. Kathryn Ross-Nash or Kathryn Ross-Nash New York Pilates, LLC is not responsible for any injury or issue caused by this or any workout/ workshop presented. \n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("No refunds- replacements or sharing of Code")]),
            _vm._v(" "),
            _c("p", [_vm._v("NO REFUND FOR DUPLICATE ORDERS")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "NO VIDEO OR PHOTOS OF THE CLASSES ARE PERMITTED – IMMEDIATE REMOVAL FROM SITE WILL RESULT FROM INFRACTION"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("There is a strong no replacement and no refund policy.")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "PLEASE! Be sure that you have a strong WIFI connection. Observe on a computer as tablets and phones cut the side view. Use ear buds and please mute yourself and turn off your video when the event begins for the best reception."
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Workouts:")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Follow along non-stop complete workout which threads from one exercise to the next to build the skills needed for the final exercise(s). These are non-instructional."
              )
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Terms and Conditions")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Take a moment to review the terms and conditions for this event- thank you."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash its successors, assigns, employees, officers, directors, shareholders, and all persons, corporations, partnerships, and other entities with which it is or may in the future become affiliated. I, the client, acknowledge all exercise and participation, virtual or in person, is done at my own risk, and Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash are not liable for personal injury, theft or loss of personal property. I also acknowledge that Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced teacher Training- The Red Thread, LLC or Kathryn Ross- Nash will not accept responsibility for theft or damage done to personal property left on the premises of Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced teacher Training- The Red Thread, LLC or Kathryn Ross- Nash or for theft or damage to automobiles or personal property left in the parking lot of Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash. Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash suggest that clients do not bring valuables on Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash premises. I hereby assume all risks associated with the use of Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash facilities. I waive all rights and rights of my heirs, administrators, executors, successors and assigns, and hereby agree to release the operator, building owner, building manager, any of its subsidiaries, and Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced teacher Training- The Red Thread, LLC or Kathryn Ross- Nash from and indemnify Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash] against, any and all claims, including, but not limited to, personal injury, including bodily injury or death, and all property damage, whether or not based on the acts or omission of Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash arising out of or in any way connected with the use of Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash facilities by myself, my Guests, or Invitees. \n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Kathryn Ross-Nash is not liable for teachers teaching or doing exercises learned from these workshops."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "I recognize that these are exercise workouts and I retain all responsibility for my well-being and of physical health to be able to perform these exercises.\n      "
              )
            ]),
            _c("p", [
              _vm._v(
                "As with this and any workout program- you should consult your doctor prior to beginning. This workout is not intended for anyone who is injured, ill or not a trained instructor of the Pilates Method by a comprehensive program of 450 hours or more. \n      "
              )
            ]),
            _c("p", [
              _vm._v(
                "The terms and conditions contained herein, along with the Rules and Regulations, constitute the full agreement between Kathryn Ross-Nash, New York Pilates, LLC, Pilates Professional Advanced Teacher Training- The Red Thread, LLC or Kathryn Ross- Nash and the client, and no oral promises made are a part of it. "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "We are not liable for attendees WIFI failure or technical issues. We are not responsible for incorrect emails upon sign up."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "All Content, Filming or Audio copies of this and any event presented in person or online are the sole property of Kathryn Ross- Nash New York Pilates, LLC or Kathryn Ross-Nash. "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "By signing up for event and purchasing ticket you are agreeing to these terms."
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("The Red Thread Method of Pilates")])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }